module.exports = __webpack_public_path__ + "static/media/Croatia.0200489b.png";